import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface LocalSessionState {
  signedIn: boolean
  signIn: () => void
  signOut: () => void
}

/**
 * Stand-in session used **only** when Entra ID is not configured
 * (`isAuthConfigured === false`). It lets the sign-in, welcome and app
 * screens all be reached locally without a tenant. Never consulted once real
 * credentials are configured — see `useAuth`.
 */
export const useLocalSessionStore = create<LocalSessionState>()(
  persist(
    (set) => ({
      signedIn: false,
      signIn: () => {
        set({ signedIn: true })
      },
      signOut: () => {
        set({ signedIn: false })
      },
    }),
    { name: 'corvinus-local-session', storage: createJSONStorage(() => sessionStorage) },
  ),
)
